import Storage from '/src/utils/storage';

// UI only, the backend enforces the restriction
const canUseTeia = () => {
    const user = Storage('local').get('user');
    return Boolean(user && typeof user === 'object' && Number(user.is_admin) === 1);
};

export default canUseTeia;
